import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ProgressComponent } from "../progress/progress.component";
import {ClrCommonFormsModule, ClrFileInputModule} from '@clr/angular';
import { NgIf } from "@angular/common";

@Component({
  selector: 'app-file-upload',
  standalone: true,
  imports: [
    ProgressComponent,
    ClrCommonFormsModule,
    NgIf,
    ClrFileInputModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FileUploadComponent,
      multi: true
    }
  ],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.sass'
})
export class FileUploadComponent implements ControlValueAccessor {
  @Input() progress = 0;
  @Input() label = 'Datei auswählen';
  @Input() description = '';
  @Input() doctype = '';

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};
  file: File | null = null;
  errorMessage: string = '';
  @ViewChild('fileInput') fileInput?: ElementRef<HTMLInputElement>;
  private readonly allowedMimeTypes = new Set<string>([
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/octet-stream',
    'application/octet-stream',
    'application/octet-stream'
  ]);
  private readonly allowedExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'dwg', 'stp', 'step'];

  @HostListener('change', ['$event.target.files'])
  emitFiles(event: FileList) {
    const file = event && event.item(0);
    this.errorMessage = '';

    if (!file) {
      this.onChange(null);
      this.file = null;
      this.clearInput();
      return;
    }

    if (file && !this.isAllowedFile(file)) {
      this.errorMessage = 'Nur PDF, DOC/DOCX, XLS/XLSX, DWG, STP und STEP sind erlaubt.';
      this.onChange(null);
      this.file = null;
      this.clearInput();
      return;
    }

    this.onChange(file);
    this.file = file;
  }

  constructor(private host: ElementRef<HTMLInputElement>) {}

  writeValue(value: any): void {
    this.file = value;
    this.clearInput();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.host.nativeElement.disabled = isDisabled;
  }

  private clearInput(): void {
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  private isAllowedFile(file: File): boolean {
    if (file.type && this.allowedMimeTypes.has(file.type)) {
      return true;
    }
    const name = file.name || '';
    const ext = name.split('.').pop()?.toLowerCase();
    if (!ext) {
      return false;
    }
    return this.allowedExtensions.includes(ext);
  }
}
